import React from 'react';

const CompassSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9m0-1C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 10.5L8 16l5.5-2.5L16 8l-5.5 2.5zm2.2 2.2L10 14l1.2-2.7L14 10l-1.3 2.7z"
        />
    </svg>
);

CompassSvg.displayName = 'CompassSvg';
export default CompassSvg;
